import { useState, useRef, useEffect, useCallback } from 'react';

export function useTaskDrawer() {
  const [selectedTaskId, setSelectedTaskId] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const drawerRef = useRef(null);
  const closedByBackRef = useRef(false);

  const openDrawer = useCallback((taskId) => {
    setSelectedTaskId(taskId);
    setIsOpen(true);
  }, []);

  const closeDrawer = useCallback(() => {
    setIsOpen(false);
    setTimeout(() => setSelectedTaskId(null), 300);
  }, []);

  // Geri tuşu ile drawer kapatma + history yönetimi
  useEffect(() => {
    if (isOpen) {
      window.history.pushState({ drawer: true }, '');
      closedByBackRef.current = false;

      const onPopState = () => {
        closedByBackRef.current = true;
        closeDrawer();
      };
      window.addEventListener('popstate', onPopState);

      return () => {
        window.removeEventListener('popstate', onPopState);
        // Manuel kapatma (overlay/X) ise pushState'i geri al
        if (!closedByBackRef.current) {
          window.history.back();
        }
      };
    }
  }, [isOpen, closeDrawer]);

  return { selectedTaskId, isOpen, drawerRef, openDrawer, closeDrawer };
}
